















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Card from "@/components/default/Card.vue";
import DataSource from "devextreme/data/data_source";
import dxCustomStore from "devextreme/data/custom_store";
import moment from "moment";
import projectMeasuringStateOverview from "@/modules/projectMeasuringStateOverview/services/projectMeasuringStateOverview";
import Datagrid from "@/components/default/Datagrid.vue";

@Component({
  components: {
    Card,
    Datagrid,
  },
})
export default class ProjectMeasuringStateAgendaOverview extends Vue {
  @Prop({ required: true })
  private project!: any;

  private mounted() {
  }

  get datasource() {
    const self = this;
    return new DataSource({
      store: new dxCustomStore({
        key: "id",
        load: async (loadOptions) => {
          const result =
            await projectMeasuringStateOverview.lookupListInProjects(
              loadOptions,
              self.project.id
            );
          return {
            data: result.data.data,
            totalCount: result.data.totalCount,
          };
        },
      }),
      paginate: true,
    });
  }

  get columns() {
    return [
      {
        dataField: "measuringStateDocumentNumber",
        caption: "Meetstaat",
      },
      {
        dataField: "start",
        caption: "Start",
      },
      {
        dataField: "end",
        caption: "Eind",
      },
      {
        dataField: "totalDays",
        caption: "Totaal aantal dagen",
        alignment: "left"
      },
      {
        dataField: "teamName",
        caption: "Team",
      },
      {
        dataField: "subcontractorName",
        caption: "Onderaannemer",
      },
      {
        dataField: "members",
        caption: "Werknemers",
      },
    ];
  }

  private convertDate(item: Date) {
    return moment(item).format("DD/MM/YYYY HH:mm");
  }
}
